@if (isOpen) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-950/35 backdrop-blur-[2px] animate-fade-in"
    (click)="onCancel()"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="relative w-full sm:w-auto min-w-0 sm:min-w-[420px] rounded-2xl bg-surface-card border-[1px] border-solid border-stone-200/90 shadow-modal p-6 text-stone-900 transition-all"
      [ngClass]="modalSizeClass"
      (click)="$event.stopPropagation()"
    >
      <!-- Close Button -->
      <button
        type="button"
        (click)="onCancel()"
        [disabled]="loading"
        class="absolute top-4 right-4 p-1.5 rounded-lg text-stone-400 hover:text-stone-700 hover:bg-surface transition-colors cursor-pointer outline-none focus:outline-none disabled:opacity-40"
        aria-label="Fermer"
      >
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <!-- Header with Generic Alert/Confirmation Icon + Title -->
      <div class="flex items-start gap-4">
        <div
          class="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 border-[1px] border-solid"
          [ngClass]="{
            'bg-red-50 text-red-600 border-red-100': variant === 'danger',
            'bg-primary-50 text-primary border-primary-100': variant === 'primary'
          }"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>
        </div>

        <div class="flex-1 min-w-0">
          <h3 class="text-base font-bold text-stone-900 leading-snug pr-8">
            {{ title | translate }}
          </h3>
          <p class="mt-1.5 text-sm text-stone-600 leading-relaxed">
            {{ message | translate }}
            @if (itemName) {
              <span class="font-semibold text-stone-800 break-words">«&nbsp;{{ itemName }}&nbsp;»</span>&nbsp;?
            }
          </p>
        </div>
      </div>

      <!-- Footer Actions -->
      <div class="mt-6 pt-4 border-t border-stone-100 flex items-center justify-end gap-2.5">
        <button
          type="button"
          (click)="onCancel()"
          [disabled]="loading"
          class="px-4 py-2 text-sm font-medium rounded-lg bg-surface text-stone-700 border-[1px] border-solid border-stone-200/90 hover:bg-stone-100 hover:text-stone-900 transition-colors cursor-pointer outline-none focus:outline-none disabled:opacity-50"
        >
          {{ cancelLabel | translate }}
        </button>

        <app-button
          [variant]="variant"
          size="md"
          [loading]="loading"
          (btnClick)="onConfirm()"
        >
          {{ confirmLabel | translate }}
        </app-button>
      </div>
    </div>
  </div>
}
